import { atomWithStorage } from "jotai/utils";
import { useAtom } from "jotai";

export type ThemeMode = "light" | "dark";

/** Persisted light/dark preference. Defaults to light. */
export const themeModeAtom = atomWithStorage<ThemeMode>(
  "vms-theme-mode",
  "light",
);

export const useThemeMode = () => {
  const [mode, setMode] = useAtom(themeModeAtom);
  const toggle = () => setMode(mode === "dark" ? "light" : "dark");
  return { mode, setMode, toggle, isDark: mode === "dark" };
};
